// Delete Strategic Demand Planner Report
export const DELETE_STRATEGIC_DEMAND_REPORT_REQUEST = 'DELETE_STRATEGIC_DEMAND_REPORT_REQUEST';
export const DELETE_STRATEGIC_DEMAND_REPORT_SUCCESS = 'DELETE_STRATEGIC_DEMAND_REPORT_SUCCESS';
export const DELETE_STRATEGIC_DEMAND_REPORT_FAILURE = 'DELETE_STRATEGIC_DEMAND_REPORT_FAILURE';

// Volume Trend Report Dropdown
export const FETCH_VOLUME_TREND_REPORTS_DD_REQUEST = 'FETCH_VOLUME_TREND_REPORTS_DD_REQUEST';
export const FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS = 'FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS';
export const FETCH_VOLUME_TREND_REPORTS_DD_FAILURE = 'FETCH_VOLUME_TREND_REPORTS_DD_FAILURE';

//Export Reports Tab Actions
export const EXPORT_STRATEGIC_REPORTS_REQUEST = 'EXPORT_STRATEGIC_REPORTS_REQUEST';
export const EXPORT_STRATEGIC_REPORTS_SUCCESS = 'EXPORT_STRATEGIC_REPORTS_SUCCESS';
export const EXPORT_STRATEGIC_REPORTS_FAILURE = 'EXPORT_STRATEGIC_REPORTS_FAILURE';

// Get Reports Tab Actions
export const FETCH_STRATEGIC_REPORTS_TAB_REQUEST = 'FETCH_STRATEGIC_REPORTS_TAB_REQUEST';
export const FETCH_STRATEGIC_REPORTS_TAB_SUCCESS = 'FETCH_STRATEGIC_REPORTS_TAB_SUCCESS';
export const FETCH_STRATEGIC_REPORTS_TAB_FAILURE = 'FETCH_STRATEGIC_REPORTS_TAB_FAILURE';

// Update Block Planning Report Note
export const UPDATE_BLOCK_PLANNING_REPORT_NOTE_REQUEST = 'UPDATE_BLOCK_PLANNING_REPORT_NOTE_REQUEST';
export const UPDATE_BLOCK_PLANNING_REPORT_NOTE_SUCCESS = 'UPDATE_BLOCK_PLANNING_REPORT_NOTE_SUCCESS';
export const UPDATE_BLOCK_PLANNING_REPORT_NOTE_FAILURE = 'UPDATE_BLOCK_PLANNING_REPORT_NOTE_FAILURE';

// Block Capacity Table Report
export const FETCH_BLOCK_CAPACITY_TABLE_REPORT_REQUEST = 'FETCH_BLOCK_CAPACITY_TABLE_REPORT_REQUEST';
export const FETCH_BLOCK_CAPACITY_TABLE_REPORT_SUCCESS = 'FETCH_BLOCK_CAPACITY_TABLE_REPORT_SUCCESS';
export const FETCH_BLOCK_CAPACITY_TABLE_REPORT_FAILURE = 'FETCH_BLOCK_CAPACITY_TABLE_REPORT_FAILURE';

// Block Planning Demand Input With Pagination
export const FETCH_BLOCK_PLANNING_DEMAND_INPUT_REQUEST = 'FETCH_BLOCK_PLANNING_DEMAND_INPUT_REQUEST';
export const FETCH_BLOCK_PLANNING_DEMAND_INPUT_SUCCESS = 'FETCH_BLOCK_PLANNING_DEMAND_INPUT_SUCCESS';
export const FETCH_BLOCK_PLANNING_DEMAND_INPUT_FAILURE = 'FETCH_BLOCK_PLANNING_DEMAND_INPUT_FAILURE';

// Site Onboarding Legend (GET)
export const FETCH_ONBOARDING_SITE_LEGEND_REQUEST = 'FETCH_ONBOARDING_SITE_LEGEND_REQUEST';
export const FETCH_ONBOARDING_SITE_LEGEND_SUCCESS = 'FETCH_ONBOARDING_SITE_LEGEND_SUCCESS';
export const FETCH_ONBOARDING_SITE_LEGEND_FAILURE = 'FETCH_ONBOARDING_SITE_LEGEND_FAILURE';

// Draft Block Demand Planning Report
export const DRAFT_BLOCK_DEMAND_PLANNING_REQUEST = 'DRAFT_BLOCK_DEMAND_PLANNING_REQUEST';
export const DRAFT_BLOCK_DEMAND_PLANNING_SUCCESS = 'DRAFT_BLOCK_DEMAND_PLANNING_SUCCESS';
export const DRAFT_BLOCK_DEMAND_PLANNING_FAILURE = 'DRAFT_BLOCK_DEMAND_PLANNING_FAILURE';

// Publish Block Demand Planning Report
export const PUBLISH_BLOCK_DEMAND_PLANNING_REQUEST = 'PUBLISH_BLOCK_DEMAND_PLANNING_REQUEST';
export const PUBLISH_BLOCK_DEMAND_PLANNING_SUCCESS = 'PUBLISH_BLOCK_DEMAND_PLANNING_SUCCESS';
export const PUBLISH_BLOCK_DEMAND_PLANNING_FAILURE = 'PUBLISH_BLOCK_DEMAND_PLANNING_FAILURE';

// Demand Input filter dropdowns
export const FETCH_DEMAND_INPUT_FILTER_DD_REQUEST = "FETCH_DEMAND_INPUT_FILTER_DD_REQUEST";
export const FETCH_DEMAND_INPUT_FILTER_DD_SUCCESS = "FETCH_DEMAND_INPUT_FILTER_DD_SUCCESS";
export const FETCH_DEMAND_INPUT_FILTER_DD_FAILURE = "FETCH_DEMAND_INPUT_FILTER_DD_FAILURE";

// strategicdemandactionType.js
export const FETCH_WORKLIST_BY_RPCE_DEMAND_REQUEST = "FETCH_WORKLIST_BY_RPCE_DEMAND_REQUEST";
export const FETCH_WORKLIST_BY_RPCE_DEMAND_SUCCESS = "FETCH_WORKLIST_BY_RPCE_DEMAND_SUCCESS";
export const FETCH_WORKLIST_BY_RPCE_DEMAND_FAILURE = "FETCH_WORKLIST_BY_RPCE_DEMAND_FAILURE";
export const FETCH_PRACTICE_BY_WORKLIST_REQUEST = "FETCH_PRACTICE_BY_WORKLIST_REQUEST";
export const FETCH_PRACTICE_BY_WORKLIST_SUCCESS = "FETCH_PRACTICE_BY_WORKLIST_SUCCESS";
export const FETCH_PRACTICE_BY_WORKLIST_FAILURE = "FETCH_PRACTICE_BY_WORKLIST_FAILURE";

// strategicdemandactionType.js
export const FETCH_SITE_ONBOARDING_PLANNER_REQUEST = 'FETCH_SITE_ONBOARDING_PLANNER_REQUEST';
export const FETCH_SITE_ONBOARDING_PLANNER_SUCCESS = 'FETCH_SITE_ONBOARDING_PLANNER_SUCCESS';
export const FETCH_SITE_ONBOARDING_PLANNER_FAILURE = 'FETCH_SITE_ONBOARDING_PLANNER_FAILURE';
// Site Offboarding Planner Action Types
export const FETCH_SITE_OFFBOARDING_PLANNER_REQUEST = 'FETCH_SITE_OFFBOARDING_PLANNER_REQUEST';
export const FETCH_SITE_OFFBOARDING_PLANNER_SUCCESS = 'FETCH_SITE_OFFBOARDING_PLANNER_SUCCESS';
export const FETCH_SITE_OFFBOARDING_PLANNER_FAILURE = 'FETCH_SITE_OFFBOARDING_PLANNER_FAILURE';

export const FETCH_BLOCK_PLANNING_DEMAND_DAILY_REQUEST = "FETCH_DEMAND_DAILY_REQUEST";
export const FETCH_BLOCK_PLANNING_DEMAND_DAILY_SUCCESS = "FETCH_DEMAND_DAILY_SUCCESS";
export const FETCH_BLOCK_PLANNING_DEMAND_DAILY_FAILURE = "FETCH_DEMAND_DAILY_FAILURE";
// strategicdemandactionType.js
export const FETCH_DEMAND_QUARTERLY_REQUEST = "FETCH_DEMAND_QUARTERLY_REQUEST";
export const FETCH_DEMAND_QUARTERLY_SUCCESS = "FETCH_DEMAND_QUARTERLY_SUCCESS";
export const FETCH_DEMAND_QUARTERLY_FAILURE = "FETCH_DEMAND_QUARTERLY_FAILURE";

//Fetch Week and Quarter 
export const FETCH_WEEK_OR_QUARTER_REQUEST = "FETCH_WEEK_OR_QUARTER_REQUEST";
export const FETCH_WEEK_OR_QUARTER_SUCCESS = "FETCH_WEEK_OR_QUARTER_SUCCESS";
export const FETCH_WEEK_OR_QUARTER_FAILURE = "FETCH_WEEK_OR_QUARTER_FAILURE";

// Reset Strategic Demand Flags
export const RESET_STRATEGIC_DEMAND_FLAGS = 'RESET_STRATEGIC_DEMAND_FLAGS';
